import ApiBase from '@/api/api-base'
import {ACTIVE_BASE_REST} from '@/api/constants'

export default class SystemDictionaryMiss extends ApiBase {
    constructor(store) {
        const path = `${ACTIVE_BASE_REST}/dictionary/miss`
        super(store, path)
    }

    addToDictionary(id , showProgress){
        return this._request({
            action: `${this._urlencode(id)}/dictionary`,
            method: 'PATCH',
            showProgress
        })
    }
}